import { ErrorHandler, Injectable, NgZone } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private zone: NgZone) {}

  handleError(error: any) {
    if (this.isChunkLoadError(error)) {
      console.error('Chunk load failed, reloading...', error);
      this.zone.runOutsideAngular(() => {
        setTimeout(() => window.location.reload(), 1000);
      });
    } else {
      console.error('Global error:', error);
    }
  }

  private isChunkLoadError(error: any): boolean {
    return (
      error &&
      (error.message?.includes('Loading chunk') ||
       error.message?.includes('Failed to fetch dynamically imported module'))
    );
  }
}
